import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    let authReq = req;

    // List of endpoints that should NOT have Authorization header
    const excludedEndpoints = [
      '/api/user/login',
      '/api/user/register',
      '/api/user/create-account',
      '/api/auth/login',
      '/api/auth/register'
    ];

    // Check if the request URL matches any excluded endpoint
    const isExcluded = excludedEndpoints.some(endpoint => req.url.includes(endpoint));

    // Only add Authorization header if token exists AND endpoint is not excluded
    if (token && !isExcluded) {
      authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // Only redirect to login on 401 if it's NOT a login/register request
        if (error.status === 401 && !isExcluded) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.removeItem('role');
          this.router.navigate(['/login']);
        }
        return throwError(() => error);
      })
    );
  }
}
